<template>
  <div style="background-color: #eeeeee" class="scroll">
    <div class="box">

      <el-breadcrumb separator-class="el-icon-arrow-right" style="padding:10px 0px;margin-top: -20px;" >
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>职位详情</el-breadcrumb-item>
        </el-breadcrumb>

      <div class="content" v-if="item && item.job_id">
   
        <div style=" display: flex;
            justify-content: space-between;
            align-items: center;
          ">

          <div class="content_childa">
            <img :src="item.logo" alt="" />
          </div>

          <div class="content_childb">

            <div>
              <span style="font-size: 20px">{{ item.title }}</span>
              <span style="color: #4d70db; padding-left: 20px">[兼职]</span>
            </div>

            <div>
              <span style="color: red; font-size: 18px">{{item.wages_max}}</span>元/{{ item.unit_str }}
              <span style="padding-left: 30px">结算方式：{{ item.method_str }}</span>
              <span style="padding: 0 30px">学历：{{ item.education_str }}</span>
              <span> 性别:{{ item.sex_str }} </span>
            </div>

          </div>
        </div>

        <div class="content_childc" v-if="item.benefits&&item.benefits.length>0">
          <span class="content_btn" v-for="(item,index) in item.benefits" :key="index">{{ item }}</span>
        </div>

        <div class="aside_box">
          <div class="aside_child" @mouseover="flag1 = true" @mouseout="flag1 = false">
            <img v-show="flag1 == false" src="@/assets/img/分享 - 未点击.png" />
            <img v-show="flag1 == true" src="@/assets/img/分享 - 悬浮.png" />
            <span style=" cursor: pointer;">分享</span>
          </div>

          <div class="aside_child" @mouseover="flag2 = true" @mouseout="flag2 = false" style="margin: 0 20px">
            <img v-show="flag2 == false && item.collect_status == 2" src="@/assets/img/收藏  - 未点击.png" />
            <img @click="collect(1)" v-show="flag2 == true && item.collect_status == 2" src="@/assets/img/收藏 - 悬浮.png" />
            <img @click="collect(2)" v-show="item.collect_status == 1" src="@/assets/img/收藏 - 已收藏.png" />
            <span style=" cursor: pointer;">收藏</span>
          </div>

          <div class="aside_child" @mouseover="flag3 = true" @mouseout="flag3 = false">
            <img v-show="flag3 == false" src="@/assets/img/投诉 - 未点击.png" />
            <img v-show="flag3 == true" src="@/assets/img/投诉 - 悬浮.png" />
            <span style=" cursor: pointer;">投诉</span>
          </div>

        </div>

        <div class="side_box">
          <div v-show="item.enroll_status == 2" class="btn2" @click="enroll" style=" cursor: pointer;">
            报名
          </div>
          <div v-show="item.enroll_status == 1" class="btn1" >已报名</div>
        </div>
      </div>




      <div class="connct_box" v-if="item && item.job_id">
        <div class="connct_box_childa">

          <div class="connct_childa_boxa">
            <img style="width: 60px; height: 60px; border-radius: 50%" 
              :src="item.user_avatar" 
              @click="diectorDetail" />
            <div class="connct_childa_boxa_child">
              <div style="font-weight: bold; font-size: 16px">
                {{ item.alias_name }}
              </div>
              <div>主管·{{ item.company_name || '' }}</div>
              <div class="btn_box">
                <div class="btn2" style=" cursor: pointer;">去聊呗</div>
              </div>
            </div>
          </div>

          <div class="connct_childa_boxb">

            <div class="connct_childa_boxb_child">
              <div class="flag"></div>
              <div style="padding-left: 20px">职位信息</div>
            </div>
            <div class="xc_box">
              <div class="xc_box_childa">
                <div class="xc_box_widths">
                  <div class="xc_box_width">项目名称</div>
                  <div>{{ item.title }}</div>
                </div>
                <div class="xc_box_widths">
                  <div class="xc_box_width">招聘人数</div>
                  <div>{{ item.number }}</div>
                </div>
                <div class="xc_box_widths">
                  <div class="xc_box_width">学历要求</div>
                  <div>{{ item.education_str }}</div>
                </div>
                <div class="xc_box_widths">
                  <div class="xc_box_width">结算方式</div>
                  <div>{{ item.method_str }}</div>
                </div>
                <div class="xc_box_widths">
                  <div class="xc_box_width">兼职性质</div>
                  <div>{{ item.type_id==1?'兼职':'全职' }}</div>
                </div>
              </div>
              <div class="xc_box_childb">
                <div class="xc_box_widths">
                  <div class="xc_box_width">活动起始日期</div>
                  <div>{{ item.activity_start_at || item.job_start_at || '暂无' }}至{{ item.activity_end_at || item.job_end_at || '' }}</div>
                </div>
                <div class="xc_box_widths">
                  <div class="xc_box_width">报名截止日期</div>
                  <div>{{ item.registration_end_time || '暂无' }}</div>
                </div>
                <div class="xc_box_widths">
                  <div class="xc_box_width">工作时间</div>
                  <div>{{ item.work_start_time || item.work_start_at || '' }}至{{ item.work_end_time || item.work_end_at || '' }}</div>
                </div>
                <div class="xc_box_widths">
                  <div class="xc_box_width">年龄要求</div>
                  <div>{{ item.age_str || (item.age_min && item.age_max ? item.age_min + '岁-' + item.age_max + '岁' : '年龄不限') }}</div>
                </div>
              </div>
            </div>

            <div class="connct_childa_boxb_child">
              <div class="flag"></div>
              <div style="padding-left: 20px">任职要求</div>
            </div>
            <div style="width: 92%; margin: 25px auto 35px">
              <div>{{ item.job_require }}</div>
            </div>

            <div class="connct_childa_boxb_child">
              <div class="flag"></div>
              <div style="padding-left: 20px">工作环境</div>
            </div>

            <div class="environment_box">
              <viewer v-for="(item,index ) in item.photo" :key="index"><img :resource="item" /></viewer>
            </div>



            <div class="connct_childa_boxb_child">
              <div class="flag"></div>
              <div style="padding-left: 20px">工作地址</div>
            </div>

            <div class="address_box">
              <div class="address_box_child">
                <div class="address_box_child_box">
                  <img src="@/assets/img/地址.png" />
                  <div class="address_flex">
                    <div v-for="(item, index) in addresslist" :key="index" 
                    style="display: flex; margin: 10px 0">
                      <div style="
                          width: 350px;overflow: hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                        ">
                        {{ item.address }}
                      </div>
                      <div style="padding-lfet: 20px">
                        剩余名额（<span style="color: red">{{
                          item.all_num-item.enroll_num
                        }}</span>）
                      </div>
                      <div>
                        距离<span style="color: #6c81b7">{{ item.gap }}km</span>
                      </div>
                    </div>
                  </div>
                </div>
        
              </div>

              <div id="map-container"></div>
            </div>

          </div>
        </div>
        <div class="connct_box_childb">
          <div class="connct_box_childb_s1">
            <img v-if="item.company && item.company.log_img" :src="item.company.log_img" style="cursor: pointer" @click="company" />
            <div style="margin:20px;0;cursor:pointer;color: blue;" @click="company">
              {{ (item.company && item.company.company_name) || item.company_name || '' }}
            </div>
            <div class="connct_box_childb_s1_child">
              <div class="connct_just">
                <div>{{ item.job_count }}</div>
                <div>在招职位</div>
              </div>
              <div class="connct_just">
                <div>{{ item.crowd_count }}</div>
                <div>在招众包</div>
              </div>
            </div>
          </div>
          <div class="connct_box_childb_s2">
            <div style="padding: 20px 0 20px 20px; font-weight: bold">
              推荐职位
            </div>
            <div class="connct_box_childb_s2_child">
              <div v-for="(item, index) in recommendlist" :key="index" class="connct_box_aside" @click="jobDetail(item.job_id)">
                <img :src="item.logo" alt="" />
                <div>
                  <div class="connct_box_aside_child">
                    <div class="connect_text">{{ item.title }}</div>
                    <span style="color: #677ebe; padding-left: 20px">[兼职]</span>
                  </div>
                  <div style="color: red; font-weight: bold">
                    {{ item.wages_max }}/{{ item.unit }}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <enroll-job-dialog  ref="enrollJobDialogRef" @callback="getInfo"></enroll-job-dialog>
  </div>
</template>

<script>
import enrollJobDialog from "@/components/job/enroll-job-dialog.vue";

import {
  jobShow,
  jobAddressList,
  recommendlist,
  addCollect,
  jobPostEnroll
} from "@/api/personal/job/index";
export default {
  components: { enrollJobDialog},

  data () {
    
    return {
      flag1: false,
      flag2: false,
      flag3: false,

      id: "",
      item: {
        log_img:""
      },
      job_id: "",
      addresslist: [],
      recommendlist: [],
      lat: "",
      lng: "",
    };
  },
  created () {
    this.job_id = this.$route.query.job_id || this.$route.query.id;
    this.getInfo();
   // this.getrecomlist();
     this.getAddressList();
  },
  mounted () {
    //创建map对象，初始化地图（TMap未加载时跳过）
    if (typeof TMap !== 'undefined') {
      var map = new TMap.Map("map-container", {
        center: new TMap.LatLng(39.98412, 116.307484), //设置地图中心点坐标
        zoom: 11, //设置地图缩放级别
        viewMode: "2D",
      });
    }
    this.getLocation();
  },
  methods: {
    //主管主页
    diectorDetail () {
      this.$router.push({
        name: "manager-index",
        query: { id: this.item.user_app_id },
      });
    },

    company () {
      this.$router.push({
        name: "company-index",
        query: { id: this.item.company_app_id, flag: 1 },
      });
    },

    //获取推荐职位信息
    jobDetail (id) {
      document.documentElement.scrollTop = 0;
      this.job_id = id;
      this.getInfo();
      this.getAddressList();
    },

    getAddressList () {
      jobAddressList({
        job_id: this.job_id,
        lat: this.lat,
        lng: this.lng,
      }).then((res) => {
        this.addresslist = res.data;
      });
    },
    getInfo () {
      jobShow({ job_id: this.job_id }).then((res) => {
        this.item = res.data;
      });
    },

    enroll(){
      this.$refs.enrollJobDialogRef.init(this.job_id,this.lat,this.lng);

    },
    
   
    //收藏
    collect (value) {
      if (value == 1) {
        let data = {
          job_id: this.job_id,
          type: 1,
          status: 1,
        };
        addCollect(data).then((res) => {
          this.getInfo();
          this.$message({
            type: "success",
            message: "收藏成功",
          });
        });
      }
      if (value == 2) {
        let data = {
          job_id: this.job_id,
          type: 1,
          status: 2,
        };
        addCollect(data).then((res) => {
          this.getInfo();
          this.$message({
            type: "success",
            message: "取消收藏",
          });
        });
      }
    },
    getrecomlist () {
      recommendlist().then((res) => {
        this.recommendlist = (res && res.data) ? res.data : [];
      }).catch(() => {
        this.recommendlist = [];
      });
    },
    getLocation () {
      if (typeof window.qq === 'undefined' || !window.qq.maps) {
        return;
      }
      var geolocation = new window.qq.maps.Geolocation(
        "EYFBZ-4BKW6-HYVS7-EEFUP-QRAH5-7LBBX",
        "referer-jianzhibei"
      );
      geolocation.getLocation(this.showPosition, this.errorPosition);
    },
    showPosition (position) {
      console.log(position);
      this.lat = position.lat;
      this.lng = position.lng;
     // this.getAddressList();
    },
    errorPosition () {
      console.log("定位失败");
      //继续定位
      this.getLocation();
    },

  
  },
};
</script>

<style lang='scss' scoped>


.box {
  width: 1200px;
  margin: auto;

  .aside_header {
    padding: 20px 0;
  }
  .connct_box {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    padding-bottom: 30px;
    .connct_box_childa {
      width: 73%;
      .connct_childa_boxa {
        height: 60px;
        border-radius: 8px;
        padding: 20px 20px 40px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: white;
        .connct_childa_boxa_child {
          width: 90%;
          height: 60px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-start;
          position: relative;
          .btn_box {
            position: absolute;
            right: 20px;
            top: 25px;
          }
        }
      }
      .connct_childa_boxb {
        margin-top: 20px;
        // height: 100px;
        padding: 30px 0;
        background-color: white;
        border-radius: 8px;
        .xc_box {
          width: 90%;
          margin: auto;
          display: flex;
          justify-content: space-around;
          align-items: flex-start;
          .xc_box_childa {
            .xc_box_widths {
              margin: 15px 0;
              display: flex;
              align-items: center;
              .xc_box_width {
                width: 90px;
              }
            }
          }
          .xc_box_childb {
            .xc_box_widths {
              margin: 15px 0;
              display: flex;
              align-items: center;
              .xc_box_width {
                width: 110px;
              }
            }
          }
        }
        .address_box {
          padding: 20px;
          box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.16);
          width: 89%;
          margin: auto;
          margin-top: 10px;
          #map-container {
            width: 100%;
            height: 300px;
          }
          .address_box_child {
            padding-bottom: 10px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            .address_box_child_box {
              display: flex;
              justify-content: space-between;
            }
            img {
              margin-right: 20px;
              width: 30px;
              height: 30px;
            }
            .address_flex {
              display: flex;
              flex-direction: column;
            }
          }
        }
        .environment_box {
          width: 92%;
          margin: 25px auto 35px;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          img {
            cursor: pointer;
            width: 100px;
            height: 100px;
            border-radius: 7px;
            margin-right: 25px;
          }
        }
        .connct_childa_boxb_child {
          display: flex;
          align-items: center;
          .flag {
            width: 12px;
            height: 40px;
            background-color: #4c71db;
          }
        }
      }
    }

    .connct_box_childb {
      width: 25%;
      .connct_box_childb_s1 {
        height: 250px;
        border-radius: 8px;
        background-color: white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 15px 0;
        img {
          width: 100px;
          border-radius: 8px;
          height: 100px;
        }
        .connct_box_childb_s1_child {
          display: flex;
          justify-content: space-between;
          width: 80%;
          .connct_just {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
        }
      }
      .connct_box_childb_s2 {
        margin-top: 6%;
        // height: 76%;
        border-radius: 8px;
        background-color: white;
        .connct_box_childb_s2_child {
          padding: 20px 0 20px 20px;
          .connct_box_aside {
            margin: 20px 0;
            display: flex;
            justify-content: space-between;
            cursor: pointer;
            img {
              border-radius: 10px;
              width: 20%;
              height: 50px;
            }
            .connct_box_aside_child {
              display: flex;
              justify-content: space-between;
              .connect_text {
                width: 100px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
            > div {
              width: 75%;
              height: 50px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              align-items: flex-start;
            }
          }
        }
      }
    }
  }
  .content {
    position: relative;
    border-radius: 8px;
    padding: 20px 20px 40px 20px;
    background-color: white;
    .side_box {
      position: absolute;
      right: 30px;
      top: 80px;
    }
    .aside_box {
      position: absolute;
      right: 30px;
      top: 20px;
      display: flex;
      align-items: center;
      .aside_child:hover {
        color: #4872d9;
      }
      .aside_child {
        display: flex;
        align-items: center;
      }
    }
    .content_childa {
      width: 8%;
      img {
        border-radius: 10px;
        width: 80px;
        height: 80px;
      }
    }
    .content_childb {
      width: 90%;
      height: 80px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
    }
    .content_childc {
      margin-top: 30px;
      width: 80%;
      .content_btn {
        display: inline-block;
        margin-right: 20px;
        padding: 5px 10px;
        color: #4c71db;
        border: 1px solid #4c71db;
        border-radius: 20px;
      }
    }
  }
  .btn1 {
    margin-left: 20px;
    margin-right: 20px;
    width: 120px;
    height: 35px;
    color: #4c71db;
    border: 1px solid #4c71db;
    border-radius: 30px;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .btn2 {
    width: 120px;
    height: 35px;
    color: white;
    border-radius: 30px;
    background-color: #4c71db;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
